import BannerSection from '@/components/main/BannerSection'
import FandomLogoSection from '@/components/main/FandomLogoSection'
import HeroSection from '@/components/main/HeroSection'
import NewsSection from '@/components/main/NewsSection'
import PreviewSection from '@/components/main/PreviewSection'
import ReviewsSection from '@/components/main/ReviewsSection'

const Main = () => {
  return (
    <>
      <HeroSection />
      <FandomLogoSection />
      <PreviewSection />
      <BannerSection />
      <ReviewsSection />
      <NewsSection />
    </>
  )
}

export default Main
